import React from "react";
import { formatDateForDisplay } from "utils/utils";

export const DisplayDate = ({ value }) => {

  
  return formatDateForDisplay(value);
};


  